import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';
import SingleSlider from './SingleSlider.js';
import InfoButton from './InfoButton.js';

class PriceCalculator extends Component {

  constructor (props, context) {
    super(props, context);
    this.state = {
      priceW: 0,
      priceH: 0,
      priceT: 0
    }
  }

  updateResultValueWeight(val){
    this.setState({
      priceW: val
    })
  }
  updateResultValueHeight(val){
    this.setState({
      priceH: val
    })
  }
  updateResultValueHair(val){
    this.setState({
      priceT: val
    })
  }

  render() {
    const {priceW, priceH, priceT} = this.state;
    const style = {
      marginBottom: "50px"
    };
    const marginStyle = {
      marginTop: "30px"
    }
    return (
        <div className="trimmis-price-calculator">
          <h2 className="trimmis-title-holder">Price calculator</h2>
          <div className="trimmis-price-calculator-content">
            <div className="row equal-height-row">
              <div className="col-sm-8" style={marginStyle}>
                <div className="row" style={style}>
                  <div className="col-sm-3 content-p">
                    Lemmikin paino
                  </div>
                  <div className="col-sm-9">
                    <SingleSlider value={priceW} change={ (priceW) => this.updateResultValueWeight(priceW) }/>
                  </div>
                </div>
                <div className="row" style={style}>
                  <div className="col-sm-3 content-p">
                    Lemmikin pituus
                  </div>
                  <div className="col-sm-9">
                    <SingleSlider value={priceH} change={ (priceH) => this.updateResultValueHeight(priceH) }/>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3 content-p">
                    Karvan pituus
                  </div>
                  <div className="col-sm-9">
                    <SingleSlider value={priceT} change={ (priceT) => this.updateResultValueHair(priceT) }/>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="trimmis-price-calculator-result">
                  <div className="trimmis-price-calculator-result-price">
                    {priceW+priceT+priceH} €
                  </div>
                  <div className="col-sm-8 col-sm-offset-2">
                    <InfoButton link={"#"} text="Aloita ajan varaus"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default PriceCalculator;



// WEBPACK FOOTER //
// ../components/PriceCalculator.js